<script lang="ts" setup>
const props = withDefaults(defineProps<
  {
    name?: string
    options: GalleryOptions
  }
>(), {
  name: () => 'media-gallery',
})

const { galleryItems, galleryOptions } = useUiMediaGallery(props.name, props.options)

const { close } = useUiDialog(props.name)

onUnmounted(() => {
  close()
})

const { breakpoint } = useApp()

// const isDesktop = ref(false)

// onBeforeMount(() => {
//   isDesktop.value = ref(useMediaQuery('(min-width: 1024px)')).value
//   useEventListener(window, 'resize', () => {
//     isDesktop.value = ref(useMediaQuery('(min-width: 1024px)')).value
//   })
// })
</script>

<template>
  <div
    v-if="galleryItems.length"
    class="media-gallery"
  >
    <div
      class="media-gallery__wrapper"
    >
      <div class="media-gallery__container">
        <LazyUiMediaGalleryMain
          :name="props.name"
          :is-desktop="['desktop', 'widescreen'].includes(breakpoint)"
          class="media-gallery__main"
        />

        <LazyUiMediaGalleryNavigation
          v-if="galleryOptions.navigation"
          :name="props.name"
          class="media-gallery__navigation"
        >
          <template #gallery-prev-icon>
            <slot name="gallery-prev-icon" />
          </template>

          <template #gallery-next-icon>
            <slot name="gallery-next-icon" />
          </template>
        </LazyUiMediaGalleryNavigation>

        <UiMediaGalleryGrids
          v-if="galleryItems.length !== 1"
          :name="props.name"
          class="media-gallery__grids media-gallery__desktop-only"
        />

        <LazyUiMediaGalleryThumbs
          v-if="galleryOptions.thumbs"
          :name="props.name"
          class="media-gallery__thumbs media-gallery__mobile-only"
          :thumbs-direction="galleryOptions.thumbsDirection"
          :thumbs-trigger="galleryOptions.thumbsTrigger"
        >
          <template #thumbs-prev-icon>
            <slot name="thumbs-prev-icon" />
          </template>

          <template #thumbs-next-icon>
            <slot name="thumbs-next-icon" />
          </template>
        </LazyUiMediaGalleryThumbs>

        <LazyUiMediaGalleryDots
          v-if="galleryOptions.dots"
          :name="props.name"
          class="media-gallery__dots"
        />

        <LazyUiMediaGalleryXofY
          v-if="galleryOptions.XofY"
          :name="props.name"
          class="media-gallery__x-of-y"
        />

        <slot />
      </div>
    </div>

    <LazyUiMediaGalleryFullscreen
      v-if="galleryOptions.fullscreen"
      :name="props.name"
    />
  </div>
</template>

<style>
@import url("~layers/app/components/Ui/MediaGallery/index.css");
</style>
